import type { GetRenewalSummaryResponse } from '@responses/renewal-summary';

import { JOB_IN_FLIGHT } from '../constants';
import type { RenewalSummaryPanelState } from '../types';

/**
 * Which body the panel shows: a job in flight wins, then a saved summary,
 * then the start screen. A failed regeneration keeps showing the summary it
 * failed to replace. A failed fetch falls back to the start screen rather
 * than spinning forever.
 */
export const derivePanelState = (
  data: GetRenewalSummaryResponse | undefined,
  isError = false,
): RenewalSummaryPanelState => {
  if (!data) return isError ? 'start' : 'loading';
  if (data.job && JOB_IN_FLIGHT[data.job.status]) return 'generating';
  if (data.summary) return 'summary';
  return 'start';
};
